module.exports = "/images/104fee1a925ccf593bf044d893ac86a6.png";